
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

export interface Jobdesc {
    id: string;
    content: string;
  }

  interface TokenResponse {
    token: string;

  }

  

@Injectable()
export class jobdescService {
    private token: string;

  constructor(private http: HttpClient) {}


  // question category
  public jobdesc(user: Jobdesc): Observable<any> {


    const base = this.http.post('/users/jobdesc', user);

    const request = base.pipe(
      map((data: TokenResponse) => {


        return data;
      })
    );
    return request;
  }

}